export default function Ruler (config) {
  const defaultHeight = 19;
  const svgroot = $('#svgroot').get(0);

  const svgNS = 'http://www.w3.org/2000/svg';
  const defaultConfig = {
    multiplier: 1,
    // Required parameters
    layout: 'horizontal',
    zoom: 1,
    value: 100,
    units: 'px', // 'em', 'ex', 'px', 'pt', 'pc', 'cm', 'mm', 'in' and ''(user units) :  http://www.w3.org/TR/SVG/coords.html#Units
    factor: 1,

    // Line config
    divisionDefaults: { strokeWidth: 1 },
    divisions: [
      { percent: 100, lineLength: 20 },
      { percent: 20, lineLength: 7 },
      { percent: 10, lineLength: 5 }
    ],

    // Text config
    textDefaults: {
      rotation: 0,
      offset: 25,
      className: 'rulez-text',
      showUnits: false,
      centerText: {
        by: 'width', // width or height
        operation: 'sub' // 'sum' or 'sub'
      }
    },
    texts: [
      { percent: 100, y: 11 }
    ],
    unitPercentage: {
      px: 100,
      mm: INKIVE.Helpers.convertUnitsToPixels(20000, 'mm') / 1000,  // 75.6
      cm: INKIVE.Helpers.convertUnitsToPixels(20000, 'cm') / 10000, // 75.6
      in: INKIVE.Helpers.convertUnitsToPixels(20000, 'in') / 20000  // 96
    }
  };

  const c = $.extend(true, {}, defaultConfig, config);
  this.config = c;

  c.element = document.createElementNS(svgNS, 'svg');
  c.element.setAttribute('style', 'pointer-events:none;');
  c.wrapper.appendChild(c.element);

  const g = document.createElementNS(svgNS, 'g');
  c.element.appendChild(g);

  const isDark = INKIVE.C.WHITE_LABEL_CONFIGURATION && INKIVE.C.WHITE_LABEL_CONFIGURATION.theme === 'dark';

  const canvasRemarkColor = isDark ? '#4b4b4b' : '#e0e0e0';
  const remarkedLineColor = isDark ? '#b8b8b8' : '#404E62';
  const lineColor = isDark ? '#b8b8b8' : '#2C353F';
  const remarkedTextColor = isDark ? '#b8b8b8' : '#2B3031';
  const textColor = isDark ? '#b8b8b8' : '#414A4B';

  /**
     * Renders ruler inside svg element
     */
  this.render = function () {
    generateDivisionsAndTexts();
  };

  this.setUnits = function (units, factor) {
    c.units = units;
    if (factor) c.factor = factor;
    $(c.wrapper).data('units', units);
    generateDivisionsAndTexts();
  };

  /**
     * Updates size with current clientWidth(height) in case it's bigger than previous one.
     * Only appends more divisions and texts if necessary.
     */
  this.resize = function (zoom, multiplier) {
    c.zoom = zoom || c.zoom;
    c.multiplier = multiplier || c.multiplier;

    while (c.zoom * c.multiplier < 0.3) {
      c.multiplier *= 2;
    }

    const bb = svgroot.getBoundingClientRect();
    if (bb.width && bb.height) {
      c.element.setAttribute('width', Math.floor(isVertical() ? defaultHeight : bb.width));
      c.element.setAttribute('height', Math.floor(isVertical() ? bb.height - 5 : defaultHeight));
    }

    isVertical() || $(c.wrapper).css('top', c.zoom * svgroot.getAttribute('height') - 40);

    generateDivisionsAndTexts();
  };

  function isVertical () {
    return c.layout === 'vertical';
  }

  function setDivisionPercent (fullPercentage, i) {
    c.divisions[i].percent = (defaultConfig.divisions[i].percent / 100) * fullPercentage;
  }

  function setTextPercent (fullPercentage, i) {
    c.texts[i].percent = (defaultConfig.texts[i].percent / 100) * fullPercentage;
  }

  function generateDivisionsAndTexts () {
    let x, y, height, width;

    for (const i in defaultConfig.divisions) {
      setDivisionPercent(defaultConfig.unitPercentage[c.units], i);
    }

    for (const i in defaultConfig.texts) {
      setTextPercent(defaultConfig.unitPercentage[c.units], i);
    }

    if (isVertical()) {
      x = 'y';
      y = 'x';
      height = 'width';
      width = 'height';
    } else {
      x = 'x';
      y = 'y';
      height = 'height';
      width = 'width';
    }

    c.divisions = $.map(c.divisions, function (entry) {
      const gap = entry.percent * c.zoom * c.multiplier * c.factor;
      return $.extend({}, c.divisionDefaults, entry, { pixelGap: gap });
    });

    c.texts = $.map(c.texts, function (entry) {
      const gap = entry.percent * c.zoom * c.multiplier * c.factor;
      return $.extend({}, c.textDefaults, entry, { pixelGap: gap });
    });

    const $g = $(g);
    const $cloned = $g.clone().addClass('cloned-ruler');
    const isClonedPresent = $g.parent().find('.cloned-ruler').length;

    isClonedPresent || $g.parent().append($cloned);
    $g.empty();

    isClonedPresent || _.defer(function () {
      const bb = svgroot.getBoundingClientRect();

      const rect = document.createElementNS(svgNS, 'rect');
      rect.setAttribute('fill', canvasRemarkColor);
      rect.setAttribute(x, ((svgroot.getAttribute(width) - c.value) / 2) * c.zoom);
      rect.setAttribute(y, (isVertical() ? 15 : 0));
      rect.setAttribute(height, 7);
      rect.setAttribute(width, c.value * c.zoom);

      g.appendChild(rect);

      const rect2 = document.createElementNS(svgNS, 'rect');
      rect2.setAttribute('fill', canvasRemarkColor);
      rect2.setAttribute(x, ((svgroot.getAttribute(width) - c.value) / 2) * c.zoom);
      rect2.setAttribute(y, (isVertical() ? 21 : 0));
      rect2.setAttribute(height, 1);
      rect2.setAttribute(width, c.value * c.zoom);

      g.appendChild(rect2);

      // Lines
      c.divisions.forEach(function (division) {
        generateDivisions(division, bb[width]);
      });

      // Text
      c.texts.forEach(function (text) {
        generateTexts(text, bb[width]);
      });

      $cloned.remove();
    });
  }

  function generateDivisions (elementConfig, width) {
    const mid = width / 2;

    for (let i = mid, j = 1; i < width; i += elementConfig.pixelGap, j++) {
      g.appendChild(createLine(i, elementConfig, i - mid > (c.value * c.zoom) / 2 ? lineColor : null));
    }

    for (let i = mid; i > 2; i -= elementConfig.pixelGap) {
      g.appendChild(createLine(i, elementConfig, i < mid - (c.value * c.zoom) / 2 ? lineColor : null));
    }
  }

  function createLine (pos, elementConfig, fill) {
    fill = fill || remarkedLineColor;

    const line = document.createElementNS(svgNS, 'rect');
    let x, y, height, width;

    if (isVertical()) {
      x = 'y';
      y = 'x';
      height = 'width';
      width = 'height';
    } else {
      x = 'x';
      y = 'y';
      height = 'height';
      width = 'width';
    }

    line.setAttribute('fill', fill);

    line.setAttribute(x, Math.floor(pos));
    line.setAttribute(y, (isVertical() ? Math.floor(defaultHeight - elementConfig.lineLength) : 0));
    line.setAttribute(height, elementConfig.lineLength);
    line.setAttribute(width, elementConfig.strokeWidth);

    return line;
  }

  function generateTexts (elementConfig, width) {
    const mid = width / 2;
    const unitMultiplier = c.units === 'px' ? 1 : INKIVE.Helpers.convertPixelsToUnits(1, c.units);

    for (let i = mid, j = 0; i < width; i += elementConfig.pixelGap, j++) {
      g.appendChild(createText(i, elementConfig, getValue(j), getColor1(i)));
    }

    for (let i = mid - elementConfig.pixelGap, j = -1; i > 0; i -= elementConfig.pixelGap, j--) {
      g.appendChild(createText(i, elementConfig, getValue(j), getColor2(i)));
    }

    function getColor1 (i) {
      return i - mid > (c.value * c.zoom) / 2 ? textColor : null;
    }

    function getColor2 (i) {
      return i < mid - (c.value * c.zoom) / 2 ? textColor : null;
    }

    function getValue (j) {
      return Math.round((j * elementConfig.percent * c.multiplier * unitMultiplier) * 10) / 10;
    }
  }

  function createText (pos, elementConfig, value, fill) {
    value = value || 0;
    fill = fill || remarkedTextColor;

    const textSvg = document.createElementNS(svgNS, 'text');
    const yPos = isVertical() ? elementConfig.y : elementConfig.y + 5;
    let x, y;
    textSvg.setAttribute('class', elementConfig.className);

    if (isVertical()) {
      x = 'y';
      y = 'x';
    } else {
      x = 'x';
      y = 'y';
    }

    pos = isVertical() ? pos - 3 : pos + 3;
    textSvg.origPos = pos;
    textSvg.origPosAttribute = x;
    textSvg.setAttribute('fill', fill);
    textSvg.setAttribute(x, pos);
    textSvg.setAttribute(y, yPos);
    rotateText(textSvg, elementConfig);
    textSvg.textContent = parseFloat(value) === 0 ? ('0' + c.units) : value;
    return textSvg;
  }

  function rotateText (textElement, elementConfig) {
    if (!elementConfig.rotation) return;

    const pos = textElement.origPos;
    const yPos = elementConfig.y;
    const rotate = isVertical()
      ? 'rotate(' + elementConfig.rotation + ' ' + yPos + ' ' + pos + ')'
      : 'rotate(' + elementConfig.rotation + ' ' + pos + ' ' + yPos + ')';

    textElement.setAttribute('transform', rotate);
  }
};
